import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, isLocale, type Locale } from '@blauturquesa/shared/locales';

// Cada idioma i namespace es carrega a part: la part pública no baixa els textos de gestió.
const loaders = import.meta.glob<{ default: Record<string, unknown> }>('./locales/*/*.json');

const STORAGE_KEY = 'bt.locale';

/** Preferència d'usuari (users.locale, quan hi hagi sessió) → desada → navegador → defecte (§11.1). */
export function detectLocale(): Locale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (isLocale(saved)) return saved;
  } catch {
    // Sense accés a localStorage (navegació privada): seguim amb el navegador.
  }
  for (const tag of navigator.languages) {
    const base = tag.slice(0, 2).toLowerCase();
    if (isLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
}

export function rememberLocale(locale: Locale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Ignorat: només és una comoditat.
  }
}

await i18n
  .use({
    type: 'backend',
    init() {},
    read(language: string, namespace: string, callback: (err: unknown, data?: Record<string, unknown>) => void) {
      const load = loaders[`./locales/${language}/${namespace}.json`];
      if (!load) return callback(null, {});
      load().then((m) => callback(null, m.default), (err: unknown) => callback(err));
    },
  })
  .use(initReactI18next)
  .init({
    lng: detectLocale(),
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    ns: ['common', 'shell'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    returnNull: false,
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
